import React, { useState, useEffect } from "react";
import { ListRole } from "../admin/ListRole";
import User from "../../api/User";
import { RoleCard } from "./RoleCard";
import { observer } from "mobx-react-lite";
import { NewRoleModal } from "./___NewRoleModal";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";

export const Role = observer(() => {
  const [visibleRoleCard, setVisibleRoleCard] = useState(false);
  const [visibleNewRole, setVisibleNewRole] = useState(false);

  useEffect(() => {
    User.allRole();
    User.allRights();
  }, []);

  const moveRole = (e) => {
    setVisibleRoleCard(true);
    User.getRole(e);
    User.allRights();
    User.groupRights();
  };

  const removeRole = (e) => {
    User.deleteRole(e);
    User.allRole();
  };

  const canAddRole =
    User.user.permission.includes("post_roles") || User.user.is_superuser;

  return (
    <section className="card admin-panel-section admin-role-section" aria-label="Роли">
      <div className="admin-panel-toolbar">
        {canAddRole ? (
          <BtnPrimaryv4
            text="Добавить роль"
            onClick={() => setVisibleNewRole(true)}
          />
        ) : null}
      </div>

      {visibleNewRole ? (
        <NewRoleModal setVisibleNewRole={setVisibleNewRole} />
      ) : null}

      <ListRole moveRole={moveRole} removeRole={removeRole} />

      {visibleRoleCard &&
      (User.user.is_superuser ||
        (User.user.permission.includes("get_all_permission") &&
          User.user.permission.includes("get_permission_id") &&
          User.user.permission.includes("get_all_rights"))) ? (
        <RoleCard setVisibleRoleCard={setVisibleRoleCard} />
      ) : null}
    </section>
  );
});
